import { render, staticRenderFns } from "./ChannelQueueHealthCmp.vue?vue&type=template&id=22abf07b&scoped=true&"
import script from "./ChannelQueueHealthCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelQueueHealthCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelQueueHealthCmp.vue?vue&type=style&index=0&id=22abf07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abf07b",
  null
  
)

export default component.exports